import React, { Component, createRef } from "react";
import { Row, Col, FormGroup, Label, Input, Spinner, Button } from "reactstrap";

import DetailBloc from '../Blocs/DetailBloc';
import { cancelToken } from '../../../../../services/adapters/kepegawaian/menuService';
import apiResponse from "../../../../../services/apiResponse";
import CustomSelect from "../../../GlobalComponents/CustomSelect";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import {
  AvForm,
  AvGroup,
  AvField,
  AvRadioGroup,
  AvRadio
} from "availity-reactstrap-validation";

class UnorComponent extends Component {
  constructor(props) {
    super(props);

    this.unorBloc = new DetailBloc();
    this.sourceRef = createRef();

    this.INITIAL_FORM_STATE = {
      skipInfo: false,
      namaSubJabatan: "",
      sesuai: false,
      unorInduk: "",
      kodeCepat: "",
      jabatanPrioritas: "",
      emp_info_unor_is_position_priority: false,
      emp_info_unor_is_position_functional: "",
      emp_info_unor_level_structure: "0",
      emp_info_unor_location: "",
      emp_info_unor_group_of_departement: "",
    };

    this.state = {
      loading: false,
      loadingsubmit: false,
      detail: {},
      detailData: {},
      option: [],
      dataForm: {},
      confirm: false,
      success: false,
      failed: false,
      gagal_txt: "",
      kotadata: [],
      form: { ...this.INITIAL_FORM_STATE },  // Clone initial state
      level_data: [
        { value: 1, label: 1 },
        { value: 2, label: 2 },
        { value: 3, label: 3 },
        { value: 4, label: 4 },
        { value: 5, label: 5 },
        { value: 6, label: 6 },
        { value: 7, label: 7 },
        { value: 8, label: 8 },
        { value: 9, label: 9 },
        { value: 10, label: 10 },
      ]
    };
  }

  componentDidMount() {
    const position_uuid = this.props.position_uuid ?? '';
    this.loadData(this.props.work_unit, position_uuid);
    this.setupSubscriptions();
  }

  componentDidUpdate(prevProps) {
    const workUnitChanged = this.props.work_unit !== prevProps.work_unit;
    const positionChanged = this.props.position_uuid !== prevProps.position_uuid;

    if (workUnitChanged || positionChanged) {
      this.setState({ 
        form: { ...this.INITIAL_FORM_STATE }, 
        detail: {},
        detailData: {},
        option: [],
        kotadata: []
      }, () => {
        this.loadData(this.props.work_unit, this.props.position_uuid ?? '');
      });
    }
  }

  componentWillUnmount() {
    if (this.sourceRef.current) {
      this.sourceRef.current.cancel();
    }
    if (this.subscriptionInfo) this.subscriptionInfo.unsubscribe();
    if (this.subscriptionDetail) this.subscriptionDetail.unsubscribe();
    if (this.subscriptionCreate) this.subscriptionCreate.unsubscribe();
  }

  setupSubscriptions = () => {
    this.subscriptionInfo = this.unorBloc.infoUnorChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({ loading: true });
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            
            if (!Array.isArray(response) || response.length < 2) {
              console.error('Invalid response format:', response);
              this.setState({ loading: false });
              return;
            }

            let subJabatanData = response[0] || [];
            let infoUnorData = response[1] || {};
            let infokotadata = response[2] || [];
            let datas = subJabatanData.map((item) => ({
              label: item.position_name,
              value: item.position_uuid,
            }));

            let datakota = infokotadata.map((item) => ({
              label: item.region_name,
              value: item.region_uuid,
            }));

            this.setState({
              detail: infoUnorData,
              option: datas,
              kotadata: datakota,
              loading: false,
            }, () => {
              this.loadDetailData();
            });
          } else {
            this.setState({ loading: false });
          }
          break;
        case apiResponse.ERROR:
          console.error('Error fetching info unor:', result);
          this.setState({ loading: false });
          break;
        default:
          break;
      }
    });

    this.subscriptionDetail = this.unorBloc.fetchdetailInfoUnorChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({ loading: true });
          break;
        case apiResponse.COMPLETED:
          if (result.data.status && result.data.response) {
            let response = result.data.response;
            
            this.setState({
              detailData: response,
              form: {
                skipInfo: response.emp_info_unor_is_skip_position || false,
                namaSubJabatan: response.emp_info_unor_sub_position || "",
                sesuai: response.emp_info_unor_is_match || false,
                unorInduk: response.emp_info_unor_parent || "",
                kodeCepat: response.emp_info_unor_fast_code || "",
                jabatanPrioritas: response.emp_info_unor_position_priority === 1 
                  ? "nasional" 
                  : response.emp_info_unor_position_priority === 0
                    ? "instansi" 
                    : "",
                emp_info_unor_is_position_priority: response.emp_info_unor_is_position_priority || false,
                emp_info_unor_is_position_functional: response.emp_info_unor_is_position_functional ? "1" : "",
                emp_info_unor_level_structure: response.emp_info_unor_level_structure || 0,
                emp_info_unor_location: response.emp_info_unor_location || "",
                emp_info_unor_group_of_departement: response.emp_info_unor_group_of_departement || "",
              },
              loading: false,
            });
          } else {
            // ─── KALAU TIDAK ADA DATA, TETAP RESET KE INITIAL ───────────────
            this.setState({ 
              detailData: {},
              form: { ...this.INITIAL_FORM_STATE },
              loading: false 
            });
          }
          break;
        case apiResponse.ERROR:
          console.error('Error fetching detail info unor:', result);
          this.setState({ loading: false });
          break;
        default:
          break;
      }
    });

    this.subscriptionCreate = this.unorBloc.fetchcreateInfoUnorChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loadingsubmit: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            gagal_txt: "Gagal!",
            loadingsubmit: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
  };

  setTokenAPI = async (currentWorkUnit, position_uuid, token) => {
    if (!currentWorkUnit) return;
    await this.unorBloc.fetchInfoUnor({ 
      uuid: currentWorkUnit, 
      position_uuid: position_uuid || '' 
    });
  };

  loadData = (workUnit, position_uuid) => {
    if (!workUnit) {
      this.setState({ 
        loading: false,
        detail: {},
        option: [],
        detailData: {},
        form: { ...this.INITIAL_FORM_STATE }  // Reset form juga
      });
      return;
    }
    
    this.setState({ loading: true });

    if (this.sourceRef.current) {
      this.sourceRef.current.cancel();
    }

    const source = cancelToken();
    this.sourceRef.current = source;
    this.setTokenAPI(workUnit, position_uuid, source.token);
  };

  loadDetailData = async () => {
    if (!this.props.work_unit || !this.props.periode) {
      console.log('Missing work_unit or periode');
      return;
    }

    this.setState({ loading: true });
    await this.unorBloc.fetchdetailInfoUnor({
      work_unit_uuid: this.props.work_unit,
      periode_uuid: this.props.periode,
      position_uuid: this.props.position_uuid ?? ''
    });
  };

  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        [name]: type === 'checkbox' ? checked : value,
      },
    }));
  };

  handleSelectChange = (name, value) => {
    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        [name]: value,
      },
    }));
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = { confirm: false };
        break;
      case "confirm":
        forState = {
          loadingsubmit: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = { success: false };
        this.loadData(this.props.work_unit, this.props.position_uuid ?? '');
        break;
      case "failed":
        forState = { failed: false };
        break;
      default:
    }
    this.setState(forState);
  };

  submitData = async () => {
    await this.unorBloc.fetchcreateInfoUnor(this.state.dataForm);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    
    const { form, detail } = this.state;
    
    let dataToSubmit = {
      work_unit_uuid: this.props.work_unit,
      periode_uuid: this.props.periode,
      position_uuid: this.props.position_uuid || "",
      position_id: detail.position_uuid || "",
      position_name: detail.position_name || "",
      is_skip_position: form.skipInfo ? 1 : 0,
      is_match: form.sesuai ? 1 : 0,
      sub_position: form.namaSubJabatan || "",
      superior: detail.unor_atasan || "",
      parent: form.unorInduk || "",
      fast_code: form.kodeCepat || "",
      is_position_priority: form.emp_info_unor_is_position_priority ? 1 : 0,
      position_priority_national: form.jabatanPrioritas === "nasional" ? 1 : 0,
      position_priority_instance: form.jabatanPrioritas === "instansi" ? 1 : 0,
      is_position_functional: form.emp_info_unor_is_position_functional ? 1 : 0,
      level_structure: values.emp_info_unor_level_structure,
      location: values.emp_info_unor_location || "",
      group_of_departement: form.emp_info_unor_group_of_departement || "",
    };

    this.setState({
      dataForm: dataToSubmit,
      confirm: true,
    });
  };

  LoadingState = () => (
    <div style={{ 
      padding: "80px 0", 
      display: "flex", 
      flexDirection: "column", 
      alignItems: "center", 
      justifyContent: "center", 
      textAlign: "center" 
    }}>
      <Spinner color="primary" style={{ width: "4rem", height: "4rem" }} />
      <h5 className="mt-4 text-muted">Mengambil data...</h5>
    </div>
  );

  EmptyState = () => (
    <div style={{ 
      padding: "80px 0", 
      textAlign: "center", 
      display: "flex", 
      flexDirection: "column", 
      alignItems: "center", 
      justifyContent: "center", 
      color: "#6c757d" 
    }}>
      <h5 className="mt-4">Tidak ada data</h5>
      <p className="text-muted">Silakan pilih unit kerja terlebih dahulu</p>
    </div>
  );

  render() {
    const { loading, detail, detailData, option, form } = this.state;

    if (loading) {
      return <this.LoadingState />;
    }

    if (!loading && (!detail || Object.keys(detail).length === 0)) {
       return <this.EmptyState />;
    }

    const displayData = {
      positionUuid: detail.position_uuid || "",
      positionName: detailData.emp_info_unor_position_name || detail.position_name || "",
      skipInfo: form.skipInfo,
      namaSubJabatan: form.namaSubJabatan || detailData.emp_info_unor_sub_position || "",
      sesuai: form.sesuai,
      unorAtasan: detailData.emp_info_unor_superior || detail.unor_atasan || "",
      unorInduk: form.unorInduk || detailData.emp_info_unor_parent || detail.unor_induk || "",
      kodeCepat: form.kodeCepat || detailData.emp_info_unor_fast_code || detail.kode_cepat || "",
    };

    return (
      <div className="p-3">
        <h5 className="mb-3 fw-bold">Data Unor</h5>
        <AvForm
          className="needs-validation"
          onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
        >
          {/* Id Jabatan + Skip Info */}
          <Row className="align-items-center mb-3">
            <Col md="8">
              <small className="text-muted">
                Id Jabatan: <span className="fw-semibold">{displayData.positionUuid}</span>
              </small>
            </Col>
            <Col md="4" className="text-md-end mt-2 mt-md-0">
              <div className="form-check d-inline-flex align-items-center">
                <Input
                  id="skipInfo"
                  name="skipInfo"
                  type="checkbox"
                  className="form-check-input me-2"
                  checked={form.skipInfo}
                  onChange={this.handleChange}
                />
                <Label htmlFor="skipInfo" className="form-check-label mb-0">
                  Skip Info Jabatan
                </Label>
              </div>
            </Col>
          </Row>

          {/* Nama Jabatan & Sub Jabatan */}
          <Row className="mb-2">
            <Col md="6">
              <FormGroup>
                <Label htmlFor="namaJabatan" className="fw-semibold">
                  Nama Jabatan <span className="text-danger">*</span>
                </Label>
                <Input
                  id="namaJabatan"
                  type="text"
                  disabled
                  value={displayData.positionName}
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label htmlFor="namaSubJabatan" className="fw-semibold">
                  Nama Sub Jabatan <span className="text-danger">*</span>
                </Label>
                <CustomSelect
                  key={`sub-jabatan-${this.props.work_unit}-${this.props.position_uuid}`}
                  name="namaSubJabatan"
                  errorMessage="Pilih Sub Jabatan"
                  options={option}
                  placeholder="Pilih Sub Jabatan"
                  defaultValue={form.namaSubJabatan}
                  onChange={(v) => {
                    this.handleSelectChange("namaSubJabatan", v ? v.value : "");
                  }}
                  isAvForm={false}
                  isClearable={true}
                />
              </FormGroup>
            </Col>
          </Row>

          {/* Checkbox Sesuai */}
          <Row className="mb-3">
            <Col md="12">
              <div className="form-check d-inline-flex align-items-center">
                <Input
                  id="sesuai"
                  name="sesuai"
                  type="checkbox"
                  className="form-check-input me-2"
                  checked={form.sesuai}
                  onChange={this.handleChange}
                />
                <Label htmlFor="sesuai" className="form-check-label mb-0">
                  Sesuai
                </Label>
              </div>
            </Col>
          </Row>

          {/* Unor Atasan & Unor Induk */}
          <Row className="mb-3">
            <Col md="6">
              <FormGroup>
                <Label htmlFor="unorAtasan" className="fw-semibold">
                  Nama Unor Atasan Struktural
                </Label>
                <Input
                  id="unorAtasan"
                  type="text"
                  value={displayData.unorAtasan}
                  disabled
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <AvGroup>
                <Label htmlFor="unorInduk" className="fw-semibold">
                  Unor Induk
                </Label>
                <AvField
                  id="unorInduk"
                  name="unorInduk"
                  type="text"
                  value={form.unorInduk}
                  onChange={this.handleChange}
                />
              </AvGroup>
            </Col>
          </Row>

          {/* Kode Cepat */}
          <Row className="mb-3">
            <Col md="6">
              <AvGroup>
                <Label htmlFor="kodeCepat" className="fw-semibold">
                  Kode Cepat
                </Label>
                <AvField
                  id="kodeCepat"
                  name="kodeCepat"
                  type="text"
                  placeholder="Masukkan Kode Cepat"
                  value={form.kodeCepat}
                  onChange={this.handleChange}
                />
              </AvGroup>
            </Col>
          </Row>

          {/* Jabatan Prioritas */}
          <Row className="mb-3">
            <Col md="12">
              <AvGroup>
                <Label className="fw-semibold">Jabatan Prioritas</Label>

                <AvRadioGroup
                  name="jabatanPrioritas"
                  value={form.jabatanPrioritas}
                  onChange={this.handleChange}
                >
                  <div style={{ display: "flex", gap: "24px", flexWrap: "wrap" }}>
                    <AvRadio
                      label="J. Prioritas Nasional"
                      value="nasional"
                    />
                    <AvRadio
                      label="J. Prioritas Instansi"
                      value="instansi"
                    />
                  </div>
                </AvRadioGroup>

              </AvGroup>
            </Col>
          </Row>

          {/* Jenis Jabatan Fungsional */}
          <Row className="mb-3">
            <Col md="12">
              <AvGroup>
                <Label className="fw-semibold mb-2">
                  Jenis Jabatan Fungsional
                </Label>
                <AvRadioGroup
                  name="emp_info_unor_is_position_functional"
                  value={form.emp_info_unor_is_position_functional}
                  onChange={this.handleChange}
                  inline
                >
                  <AvRadio label="Fungsional Murni" value="1" />
                </AvRadioGroup>
              </AvGroup>
            </Col>
          </Row>

          {/* Level Struktur & Lokasi Unor */}
          <Row className="mb-3">
            <Col md="6">
              <AvGroup>
                <Label className="fw-semibold">Level Struktur <span className="text-danger">*</span></Label>
                 <CustomSelect
                    key={`level-${this.props.work_unit}-${this.props.position_uuid}`} 
                    name="emp_info_unor_level_structure"
                    errorMessage="Pilih Level Struktur"
                    options={this.state.level_data}
                    validate={{ required: { value: true } }}
                    placeholder="Pilih Level Struktur"
                    defaultValue={form.emp_info_unor_level_structure}
                  />
              </AvGroup>
            </Col>

            <Col md="6">
              <AvGroup>
                <Label className="fw-semibold d-flex align-items-center gap-2">
                  Lokasi Unor <span className="text-danger">*</span>
                </Label>
                  <CustomSelect
                    key={`location-${this.props.work_unit}-${this.props.position_uuid}`} 
                    name="emp_info_unor_location"
                    errorMessage="Pilih Lokasi Unor"
                    options={this.state.kotadata}
                    validate={{ required: { value: true } }}
                    placeholder="Pilih Lokasi Unor"
                    defaultValue={form.emp_info_unor_location}
                  />
              </AvGroup>
            </Col>
          </Row>

          {/* Rumpun Jabatan */}
          <Row className="mb-3">
            <Col md="12">
              <AvGroup>
                <Label htmlFor="emp_info_unor_group_of_departement" className="fw-semibold">
                  Rumpun Jabatan <span className="text-danger">*</span>
                </Label>
                <AvField
                  id="emp_info_unor_group_of_departement"
                  name="emp_info_unor_group_of_departement"
                  type="text"
                  required
                  value={form.emp_info_unor_group_of_departement}
                  onChange={this.handleChange}
                  errorMessage="Rumpun Jabatan wajib diisi"
                  placeholder="Masukkan Rumpun Jabatan"
                />
              </AvGroup>
            </Col>
          </Row>

          <Row>
            <Col md="12" className="text-end">
              <Button 
                type="submit" 
                color="primary"
                disabled={this.state.loadingsubmit}
              >
                {this.state.loadingsubmit ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Menyimpan...
                  </>
                ) : (
                  'Simpan Data Unor'
                )}
              </Button>
            </Col>
          </Row>
        </AvForm>

        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle={this.state.gagal_txt || "Gagal!"}
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loadingsubmit}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
      </div>
    );
  }
}

export default UnorComponent;